import React from 'react';
import PropTypes from 'prop-types';

import ScholarCard from '../ScholarCard';
import { ArrowLeftCircle } from '../Icons';

const Scholars = ({ handleBack, scholars, title, ...rest }) => {
  const hasTitle = !!title;
  const hasScholars = !!scholars?.length;

  return (
    <div className='scholars' {...rest}>
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='scholars__container'>
              {hasTitle && (
                <div className='scholars__header'>
                  <div className='scholars__title'>{title}</div>
                </div>
              )}
              {hasScholars && (
                <div className='scholars__list'>
                  {scholars.map((item, index) => {
                    return (
                      <div className='scholars__list-item' key={`scholars__list-item-${index}`}>
                        <ScholarCard {...item} />
                      </div>
                    );
                  })}
                </div>
              )}

              <div className='scholars__controls'>
                <button className='scholars__back-cta' onClick={() => handleBack()}>
                  <ArrowLeftCircle className='scholars__back-cta-icon' />
                  <span className='scholars__back-cta-title'>Back to all articles</span>
                </button>
                <a
                  href='https://static-mi.manhattan.institute/staff'
                  target='_blank'
                  rel='noreferrer'
                >
                  Link to Full Staff Directory
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Scholars.propTypes = {
  handleBack: PropTypes.func,
  scholars: PropTypes.array,
  title: PropTypes.string,
};

export default Scholars;
